<template>
  <v-container
    class="sidebar py-0"
    fill-height
  >
    <v-row
      style="height:100%"
      align="start"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <v-avatar
          size="200"
        >
          <img
            :src="require('@/assets/avatar.jpg')"
            alt="Vincent CAUDRON"
          >
        </v-avatar>
      </v-col>
      <v-col
        cols="12"
        class="text-center"
      >
        <h2>{{ $t('Sidebar.name') }}</h2>
        <p>{{ $t('Sidebar.title') }}</p>

        <h2>{{ $t('Sidebar.contact') }}</h2>
        <p>
          {{ $t('Sidebar.email') }}
          <br>
          {{ $t('Sidebar.phone') }}
          <br>
          {{ $t('Sidebar.website') }}
        </p>

        <h2>{{ $t('Sidebar.social.title') }}</h2>
        <p>
          <span
            v-for="(item, index) in $t('Sidebar.social.list')"
            :key="index"
          >
            {{ item }}
            <br>
          </span>
        </p>

        <h2>{{ $t('Sidebar.formation.title') }}</h2>
        <p
          v-for="(item, index) in $t('Sidebar.formation.list')"
          :key="index"
        >
          {{ item.name }}
          <br>
          {{ item.title }}
          <br>
          {{ item.year }}
        </p>

        <h2>{{ $t('Sidebar.skill.title') }}</h2>
        <p>
          <v-chip
            v-for="(item, index) in $t('Sidebar.skill.list')"
            :key="index"
            class="ma-2"
          >
            {{ item }}
          </v-chip>
        </p>
        
        <h2>{{ $t('Sidebar.language.title') }}</h2>
        <p>
          <span
            v-for="(item, index) in $t('Sidebar.language.list')"
            :key="index"
          >
            {{ item }}
            <br>
          </span>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Sidebar',
  data: () => ({}),
}
</script>

<style scoped>
.sidebar{
  background-color: rgba(66, 66, 66, .85);
  color:white;
}
</style>